import { Component } from '@angular/core';

@Component({
  selector: 'app-order-placed',
  templateUrl: './order-placed.component.html',
  styleUrl: './order-placed.component.scss'
})
export class OrderPlacedComponent {

}
